// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d4bc890c","396":"6d88b57b","453":"fac6e068","455":"d34112c3","857":"952bb8b3","977":"395c967a"}[chunkId] + ".chunk.js";
};